import { useRef, useEffect } from 'react';

const PageHeader = ({ caption, title, subtitle, bgImage }) => {
  const headerRef = useRef(null);

  useEffect(() => {
    if (headerRef.current) {
      headerRef.current.classList.add('animate-fade-in');
    }
  }, []);

  return (
    <div
      ref={headerRef}
      className="relative overflow-hidden"
      style={{ background: bgImage ? undefined : '#F5F5F5' }}
    >
      {bgImage && (
        <>
          <div className="absolute inset-0">
            <img src={bgImage} alt="" className="w-full h-full object-cover" loading="eager" />
          </div>
          <div className="absolute inset-0 bg-white/85" />
        </>
      )}
      <div className="relative sol-container" style={{ padding: '8rem 0 3.5rem' }}>
        <div className="sol-container">
          {caption && <p className="sol-caption mb-3">{caption}</p>}
          <h1
            className="text-4xl md:text-5xl font-bold tracking-tight text-[#333333]"
            style={{ fontFamily: 'Manrope, sans-serif' }}
          >
            {title}
          </h1>
          {subtitle && (
            <p className="text-[#525252] mt-4 max-w-xl text-lg">{subtitle}</p>
          )}
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-[#E5E5E5]" />
    </div>
  );
};

export default PageHeader;
